import { RouteObject } from "react-router";

import { convertRouteModule } from "../../../lib/routing";

export { Agent } from "./agent";
export const agentRoutes: Array<RouteObject> = [
  { index: true, lazy: async () => convertRouteModule(await import("./agent")) },
];
